module.exports = __webpack_public_path__ + "img/labmem_text_btntest_en.7bab7484.png";